module.exports = __webpack_public_path__ + "static/media/icon_learning.f2f073d2.svg";